var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.globalResources.portalType === this.portalType.Music)?_c('MusicCollectionCard',{attrs:{"item":_vm.item}}):(this.globalResources.portalType === this.portalType.Game)?_c('GameCollectionCard',{attrs:{"item":_vm.item}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }